import { truncate as lodashTruncate } from 'lodash'

const truncate = function (stringToTruncate, length = 200) {
    return lodashTruncate(stringToTruncate, { 'length': length })
}

export { truncate }